export const TeethArchEnum = {
  MAXILLARY: "MAXILLARY",
  MANDIBULAR: "MANDIBULAR",
} as const;

export type TeethArch = (typeof TeethArchEnum)[keyof typeof TeethArchEnum];
export type Arch = TeethArch | "BIMAXILLARY";

export const ArchEnum: Record<Arch, Arch> = {
  MAXILLARY: "MAXILLARY",
  MANDIBULAR: "MANDIBULAR",
  BIMAXILLARY: "BIMAXILLARY",
};

/** Display order of the arches, from the upper jaw to the lower one. */
export const ORDERED_ARCHES: TeethArch[] = [
  TeethArchEnum.MAXILLARY,
  TeethArchEnum.MANDIBULAR,
];

export type Quadrant = "Q1" | "Q2" | "Q3" | "Q4";
export const QuadrantEnum: Record<Quadrant, Quadrant> = {
  Q1: "Q1",
  Q2: "Q2",
  Q3: "Q3",
  Q4: "Q4",
};
